import { createQuery } from "react-query-kit";
import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import { AxiosError } from "axios";
import { SubGroup } from "../../models/transaction/productinvoice-model";
import { Session } from "inspector";
import SessionModel from "../../models/masters/session-model";

const url = getEndPoint(API_END_POINT.ORDER) + "/api/ProductInvoice/GetAllSubGroup";
export const useGetSubGroupProductInvoice = createQuery<
    SubGroup[],
    null,
    AxiosError
>({
    queryKey: ["keySubGroupProductlist"],
    fetcher: (params) =>
        getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
        // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
    refetchOnWindowFocus: false,
});


const sessionUrl = getEndPoint(API_END_POINT.ORDER) + "/api/ProductInvoice/GetAllSession";
export const useGetSessionForProductInv = createQuery<
    SessionModel[],
    null,
    AxiosError
>({
    queryKey: ["keySessionProductlist"],
    fetcher: (params) =>
        getDataWithToken<any>(sessionUrl).then((response) => response.data?.result || console.log(response)),
        // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
    refetchOnWindowFocus: false,
});